export default "__VITE_ASSET__cN11X_80__"